<template>
  <div>

    <!-- Exibe a lista de produtos -->
    <div :class="isInputError('products')" @click="removeError('products')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">{{ $t('views.seller.integrations.config.save.product.title') }}</strong>
        <a href="#" @click.prevent="selectAll('products')" class="select-all float-right">
          {{ products?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="products.value"
        :options="products.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :limit-text="limitText" 
        :limit="4" 
        :searchable="true"
        :loading="loadingProducts"
        :group-select="true"
        :select-label="'Select'"
        :disabled="loading"
        class="new-style"
        group-values="options"
        group-label="group"
        :placeholder="$t('views.seller.integrations.config.save.product.search')" 
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="option__title" v-if="props.option?.$isLabel">
            {{ props.option.$groupLabel.name }}
            <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.save.product.select_all') }}</span>
            <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.save.product.remove_all') }}</span>
          </span>
          <span class="d-flex option__item" v-else>
            <img :src="isOptionSelected('products', props.option.id)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">{{ $t('views.seller.integrations.config.save.product.select') }}</span>
        </template>
        <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
        <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
        <div slot="limit" class="multiselect__tag limit">+{{ products?.value?.length - 4 }}</div>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('products') }}</span>
    </div>

    <!-- Exibe o token -->
    <div :class="isInputError('token')" @click="removeError('token')">
      <strong class="title-medium mt-4">API Key</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
        <b-form-input id="input-token" :placeholder="`Informe o API Key do ${integration.name}`" class="form-input" v-model="token" :disabled="loading" trim></b-form-input>
      </b-form-group>
      <span class="show-error">
        {{ showError('token') }}
      </span>
    </div>

    <!-- Exibe eventos -->
    <div :class="isInputError('events')" @click="removeError('events')">
      <strong class="title-medium mt-4">{{ $t('views.seller.integrations.config.save.event.title') }}</strong>
      <span class="show-error">{{ showError('events') }}</span>
      <div class="d-flex bd-highlight my-3">
        <switch-group :label="$t('views.seller.integrations.config.save.event.label.sales')" v-model="selectEvent" :options="events.options_sales" :disabled="loading" />
      </div>
    </div>

    <!-- Botao Salvar -->
    <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveItegration">
      <template v-if="loadingSave">
        <b-spinner variant="light" class="mr-2" small></b-spinner>
        {{ $t('views.seller.integrations.config.save.button.saving') }}
      </template>
      <template v-else>
        {{ $t('views.seller.integrations.config.save.button.save') }}
      </template>
    </b-button>

  </div>
</template>

<script>

import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import SwitchGroup from '@/components/shared/forms/SwitchGroup';
import CallbackService from '@/services/resources/CallbackService';

export default {
  name: "IntegrationsConfigUtmify",
  components: {
    Multiselect,
    SwitchGroup
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Utmify' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    events: {
      type: Object,
      required: true,
      default: () => ({
        options_sales: [],
        options_contracts: [],
        options_sales_recovery: []
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    selectAll: {
      type: Function,
      required: true
    },
    organizeEvents: {
      type: Function,
      required: true
    },
    isOptionSelected: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    updateCallbacks: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => {
    return {
      loadingSave: false,
      selectEvent: [],
      url: 'https://api.utmify.com.br',
      token: '',
    }
  },
  methods: {
    resetForm() {
      this.products.value = null;
      this.token = '';
      this.selectEvent = [];
    },
    saveItegration() {

      const products = this.products?.value?.map(product => product.id) || [];
      const events = this.organizeEvents(this.selectEvent);

      CallbackService.build().create({
        url: this.url,
        token: this.token,
        products: products,
        events
      }, null, `integrations/group/${this.integration.id}`, { suppressErrorNotify: true })
      .then((response) => {
        if (response?.confirm_update?.length > 0) {
          const dataUpdate = {
            url: this.url,
            token: this.token,
            events
          };

          this.confirmUpdate(response.confirm_update, dataUpdate);
        }
        else {
          this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
            title: this.$t('views.seller.integrations.config.toast.save.success.title'),
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }

        this.resetForm();
        this.fetchCallbacks();
      })
      .catch(err => {
        this.mountInputError(err.response.data);
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
    },
    confirmUpdate(data, dataUpdate) {

      Vue.swal({
        title: this.$t('views.seller.integrations.config.alert.update.title'),
        html: `<p>${this.$t('views.seller.integrations.config.alert.update.message')}</p>
        <ul>
          ${data.map(item => `<li>${item.product_name}</li>`).join('')}
        </ul>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('views.seller.integrations.config.alert.update.ok'),
        cancelButtonText: this.$t('views.seller.integrations.config.alert.update.cancel'),
        customClass: "sweet-container-new",
        confirmButtonClass: "btn btn-primary text-nowrap",
        cancelButtonClass: "btn btn-outline-secondary text-nowrap",
        buttonsStyling: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateCallbacks({
            force_update: true,
            products: data, 
            dataUpdate: dataUpdate
          });
        }
      });
    },
  }
}
</script>